// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import zappy from '@zappy-ride/library.react.components';
import { useCalculationSelectors } from '../../../../selectors/calculations';

export const OutputLCFS = ({ design }: { design: string }) => {
  const { schema } = zappy.useDesign(design);
  const [{ data, status }] = useCalculationSelectors('lcfsCosts');

  if (status.isLoading) return 'Loading';

  if (status.missingRequiredInformation)
    return 'Missing required info for calculations';

  return (
    <zappy.FactoryComponent schema={schema} data-design={design}>
      <zappy.ContentContainer design={design} values={data || {}} />
    </zappy.FactoryComponent>
  );
};

OutputLCFS.displayName = 'OutputLCFS';
